import { Outlet } from 'react-router-dom';

export function Settings() {
  return (
    <Outlet />
  );
}
